export default __webpack_public_path__ + "static/media/feeder-pillars.bedcc948.jpg";